module.exports = __webpack_public_path__ + "static/media/culvers.7c21f1bf.png";